module.exports = __webpack_public_path__ + "static/img/gongzong1.b501a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/soft/gongzong1.jpg
// module id = aLsv
// module chunks = 0